// The deals as a pair of pixel starburst stickers (snippets/dotcom-deals.liquid):
// "Any 2 for €40!" and "3+ ship free!". One pair per page, stuck to the page
// rather than to any one shirt:
// - on a shirt's page: beside the price
// - anywhere else: in the gap above the shirts, on the right (on a phone,
//   on the corner of the first row)
// Each one comes off once the basket has what it takes (2 shirts, then 3).
// On the home page they can be popped: click one (or Enter on it) and it
// blows apart in pixels, with a bang. It's back 5 minutes later, to be popped again.
(function () {
  // none on the page for unsubscribing from emails
  if (/\/account\/unsubscribe(\/|$)/.test(location.pathname)) return;
  // (the price of two is in the visitor's own currency: snippets/dotcom-deals.liquid)
  var prices = window.DOTCOM_DEALS || { two: '€40' };
  var DEALS = [
    { id: 'two', lines: ['Any 2', 'for'], big: prices.two + '!', needs: 2 },
    { id: 'ship', big: '3+', lines: ['ship', 'free!'], needs: 3, bigFirst: true },
  ];
  var phone = matchMedia('(max-width: 749px)');
  var pair = null;
  var count = prices.count || 0;
  var poppable = !!prices.home;
  var POPPED_KEY = 'dotcom-stickers-popped'; // { deal id: when it was popped }
  var BACK_AFTER = 5 * 60 * 1000;
  var comeBack = {}; // deal id: the timer that puts it back

  // a starburst drawn small with hard edges and a one-pixel ink outline,
  // then shown at `scale` screen px per pixel
  function burstCanvas(n) {
    var c = document.createElement('canvas');
    c.width = c.height = n;
    var g = c.getContext('2d');
    var spikes = 12;
    g.beginPath();
    for (var i = 0; i < spikes * 2; i++) {
      var r = i % 2 ? n / 2 - 3.2 : n / 2 - 0.6;
      var a = (i / (spikes * 2)) * Math.PI * 2 - Math.PI / 2;
      g.lineTo(n / 2 + Math.cos(a) * r, n / 2 + Math.sin(a) * r);
    }
    g.fill();
    var img = g.getImageData(0, 0, n, n);
    var solid = function (x, y) {
      return x >= 0 && y >= 0 && x < n && y < n && img.data[(y * n + x) * 4 + 3] > 140;
    };
    var out = g.createImageData(n, n);
    for (var y = 0; y < n; y++) {
      for (var x = 0; x < n; x++) {
        if (!solid(x, y)) continue;
        var edge = !solid(x - 1, y) || !solid(x + 1, y) || !solid(x, y - 1) || !solid(x, y + 1);
        out.data.set(edge ? [18, 18, 18, 255] : [255, 210, 63, 255], (y * n + x) * 4);
      }
    }
    g.putImageData(out, 0, 0);
    return c;
  }

  function burst(deal, n, scale, tilt) {
    var b = document.createElement('div');
    b.className = 'dotcom-deals__burst';
    b.dataset.deal = deal.id;
    b.style.width = b.style.height = n * scale + 'px';
    b.style.transform = 'rotate(' + tilt + 'deg)';
    b.appendChild(burstCanvas(n));
    var t = document.createElement('span');
    t.className = 'dotcom-deals__text';
    // (a long price, like £35.20, gets smaller to fit)
    var size = Math.min(1.6, 9 / deal.big.length);
    var big = '<b style="font-size: ' + size.toFixed(2) + 'em">' + deal.big + '</b>';
    var small = deal.lines.map(function (l) { return '<span>' + l + '</span>'; }).join('');
    t.innerHTML = deal.bigFirst ? big + small : small + big;
    b.appendChild(t);
    return b;
  }

  // the 2-for sticker the bigger of the two: stacked corner to corner, or
  // (in a phone's header, or above the add to cart button, where there's
  // little height) side by side
  function makePair(scale, sideBySide) {
    var p = document.createElement('div');
    p.className = 'dotcom-deals';
    p.setAttribute('aria-label', 'Any 2 t-shirts for ' + prices.two + '. 3 or more ship free.');
    p.setAttribute('role', 'img');
    var n = sideBySide ? 33 : 40;
    var m = sideBySide ? 29 : 35;
    var big = burst(DEALS[0], n, scale, 8);
    var small = burst(DEALS[1], m, scale, -10);
    big.style.top = '0';
    small.style.bottom = '0';
    if (sideBySide) {
      big.style.left = '0';
      small.style.left = Math.round(n * scale * 0.82) + 'px';
      p.style.width = Math.round((n * 0.82 + m) * scale) + 'px';
      p.style.height = n * scale + 'px';
    } else {
      big.style.right = '0';
      small.style.left = '0';
      p.style.width = Math.round((n * 0.84 + m) * scale) + 'px';
      p.style.height = Math.round((n * 0.72 + m) * scale) + 'px';
    }
    p.appendChild(big);
    p.appendChild(small);
    return p;
  }

  // where the pair goes on this page, and how it sits there
  function spot() {
    var price = document.querySelector('.product__info-container > [id^="price-"]');
    if (price) return { kind: 'price', anchor: price };
    var button = document.querySelector('product-form .product-form__submit, .product-form__submit');
    if (button) return { kind: 'cart', anchor: button };
    var grid = document.querySelector('.product-grid');
    return grid ? { kind: 'grid', anchor: grid } : null;
  }

  function place() {
    if (pair) pair.remove();
    pair = null;
    var where = spot();
    if (!where) return;
    var scale = phone.matches ? 2 : 3;
    // (side by side, except by the grid on a computer, where there's room to
    // stagger them)
    pair = makePair(scale, where.kind !== 'grid' || phone.matches);
    pair.classList.add('dotcom-deals--' + where.kind);
    if (poppable && where.kind !== 'cart' && where.kind !== 'price') makePoppable();
    var a = where.anchor;
    // beside the price, the button or the grid, in their own box
    var box = a.parentElement;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.appendChild(pair);
    var w = pair.offsetWidth;
    var h = pair.offsetHeight;
    // (never off the edge of the window)
    var room = document.documentElement.clientWidth - box.getBoundingClientRect().left - w - 6;
    if (where.kind === 'price') {
      // at the right end of the shirt's details, level with the price (on
      // a computer a little higher, as they're bigger there and the line
      // below the price is short)
      pair.style.left = Math.min(box.clientWidth - w, room) + 'px';
      pair.style.top = a.offsetTop + (phone.matches ? (a.offsetHeight - h) / 2 : -6) + 'px';
    } else if (where.kind === 'cart') {
      // side by side just above the button, at its right end, beside the
      // quantity box
      pair.style.left = Math.min(a.offsetLeft + a.offsetWidth - w + (phone.matches ? 0 : 28), room) + 'px';
      pair.style.top = a.offsetTop - h - 4 + 'px';
    } else {
      // out into the margin a little (on a phone, where there isn't one, over
      // the corner of the first row), and below the bar with the
      // announcements, the currency and "Play with dotcom" in it
      var bar = document.querySelector('.utility-bar');
      var below = bar ? bar.getBoundingClientRect().bottom - box.getBoundingClientRect().top + 6 : -Infinity;
      if (phone.matches) {
        pair.style.left = Math.min(a.offsetLeft + a.offsetWidth - w, room) + 'px';
        pair.style.top = Math.max(a.offsetTop - h + 20, below) + 'px';
      } else {
        pair.style.left = Math.min(a.offsetLeft + a.offsetWidth - w * 0.62, room) + 'px';
        pair.style.top = Math.max(a.offsetTop - h * 0.55, below) + 'px';
      }
    }
    show();
  }

  // the stickers for deals the basket already has come off
  function show() {
    if (!pair) return;
    var left = 0;
    var gone = poppable ? popped() : {};
    DEALS.forEach(function (deal) {
      var b = pair.querySelector('[data-deal="' + deal.id + '"]');
      var was = b.hidden;
      var off = Date.now() - (gone[deal.id] || 0) < BACK_AFTER;
      b.hidden = count >= deal.needs || off;
      // back after being popped: slapped back on
      if (was && !b.hidden && gone[deal.id]) b.classList.add('is-back');
      if (off && !comeBack[deal.id]) {
        comeBack[deal.id] = setTimeout(function () {
          comeBack[deal.id] = 0;
          show();
        }, gone[deal.id] + BACK_AFTER - Date.now() + 50);
      }
      if (!b.hidden) left++;
    });
    pair.hidden = !left;
  }

  // ── Popping them (the home page only) ──
  function popped() {
    try {
      var p = JSON.parse(localStorage.getItem(POPPED_KEY));
      return p && typeof p === 'object' && !Array.isArray(p) ? p : {};
    } catch (e) {
      return {};
    }
  }
  function makePoppable() {
    pair.classList.add('dotcom-deals--poppable');
    pair.setAttribute('role', 'group');
    DEALS.forEach(function (deal) {
      var b = pair.querySelector('[data-deal="' + deal.id + '"]');
      b.setAttribute('role', 'button');
      b.setAttribute('tabindex', '0');
      b.setAttribute('aria-label', 'Pop the sticker: ' + b.textContent.replace(/\s+/g, ' ').trim());
      b.addEventListener('click', function () {
        pop(b);
      });
      b.addEventListener('animationend', function () {
        b.classList.remove('is-back');
      });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          pop(b);
        }
      });
    });
  }
  function pop(b) {
    var gone = popped();
    gone[b.dataset.deal] = Date.now();
    try {
      localStorage.setItem(POPPED_KEY, JSON.stringify(gone));
    } catch (e) {}
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) boom(b);
    bang();
    show();
  }
  // dotcom's explosion (from the mascot repo's scripts/sounds.py), at his
  // volume: on a computer with the sound on, like all his sounds
  function bang() {
    var muted = false;
    try {
      muted = localStorage.getItem('dotcom-muted') === '1';
    } catch (e) {}
    if (muted || 'ontouchstart' in window || !window.MASCOT_ASSET_BASE) return;
    var a = new Audio(window.MASCOT_ASSET_BASE + 'sfx-dotcom-explosion.mp3');
    a.volume = 0.08;
    a.play().catch(function () {});
  }
  // Every pixel of the sticker flies off on its own, with a flash where it was
  function boom(b) {
    var canvas = b.querySelector('canvas');
    var n = canvas.width;
    var r = b.getBoundingClientRect();
    var scale = b.offsetWidth / n;
    var size = n * 3;
    var fx = document.createElement('canvas');
    fx.className = 'dotcom-deals__boom';
    fx.width = fx.height = size;
    fx.style.width = fx.style.height = size * scale + 'px';
    fx.style.left = r.left + r.width / 2 - (size * scale) / 2 + 'px';
    fx.style.top = r.top + r.height / 2 - (size * scale) / 2 + 'px';
    document.body.appendChild(fx);
    var g = fx.getContext('2d');
    var src = canvas.getContext('2d').getImageData(0, 0, n, n).data;
    var bits = [];
    for (var y = 0; y < n; y++) {
      for (var x = 0; x < n; x++) {
        var i = (y * n + x) * 4;
        if (src[i + 3] < 128) continue;
        var dx = x - n / 2 + Math.random() - 0.5;
        var dy = y - n / 2 + Math.random() - 0.5;
        var push = 2.2 + Math.random() * 2.4;
        bits.push({
          x: x + n,
          y: y + n,
          vx: dx * push,
          vy: dy * push - 10 - Math.random() * 14,
          life: 0.45 + Math.random() * 0.45,
          color: 'rgb(' + src[i] + ',' + src[i + 1] + ',' + src[i + 2] + ')',
        });
      }
    }
    // a few red ones, for the letters
    for (var k = 0; k < 28; k++) {
      bits.push({ x: size / 2, y: size / 2, vx: (Math.random() - 0.5) * 70, vy: (Math.random() - 0.5) * 70 - 12, life: 0.3 + Math.random() * 0.4, color: '#d3252b' });
    }
    var start = performance.now();
    var last = start;
    function frame(now) {
      var t = (now - start) / 1000;
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      g.clearRect(0, 0, size, size);
      if (t < 0.09) {
        g.fillStyle = t < 0.045 ? '#ffffff' : '#fff3a8';
        g.beginPath();
        g.arc(size / 2, size / 2, n * (0.35 + t * 5), 0, Math.PI * 2);
        g.fill();
      }
      var alive = 0;
      for (var j = 0; j < bits.length; j++) {
        var p = bits[j];
        if (t > p.life) continue;
        alive++;
        p.vy += 70 * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        g.fillStyle = p.color;
        g.fillRect(Math.round(p.x), Math.round(p.y), 1, 1);
      }
      if (alive || t < 0.1) requestAnimationFrame(frame);
      else fx.remove();
    }
    requestAnimationFrame(frame);
  }

  function readCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        count = cart.item_count || 0;
        show();
      })
      .catch(function () {});
  }

  function start() {
    place();
    readCart();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, readCart);
    phone.addEventListener('change', place);
    var resizing = 0;
    addEventListener('resize', function () {
      clearTimeout(resizing);
      resizing = setTimeout(place, 150);
    });
    // a shirt's page redraws its buttons when a colour or size is picked
    setInterval(function () {
      if (pair && !pair.isConnected) place();
    }, 1000);
    addEventListener('pageshow', function (e) {
      if (e.persisted) readCart();
    });
    // the currency switched (snippets/dotcom-currency.liquid): the new price
    document.addEventListener('dotcom:deals', function () {
      prices = window.DOTCOM_DEALS || prices;
      DEALS[0].big = prices.two + '!';
      place();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
